import {
  CombinedGraphQLErrors,
  CombinedProtocolErrors,
  ErrorLike,
  LocalStateError,
  ServerError,
  ServerParseError,
  UnconventionalError,
} from '@apollo/client'

import * as Sentry from '@sentry/react'
import isTestEnv from 'utils/isTestEnv'

export function logException(
  error: Error | ErrorLike | string,
  options: { extras?: Record<string, unknown> } = {}
) {
  const registerError = (error: CombinedGraphQLErrors | Error | string) => {
    Sentry.withScope((scope) => {
      if (options.extras) {
        Object.entries(options.extras).forEach(([key, value]) => {
          scope.setExtra(key, value)
        })
      }

      Sentry.captureException(error)
    })

    if (!isTestEnv) console.error(error)
  }

  if (CombinedGraphQLErrors.is(error)) {
    // Handle GraphQL errors
    const errors = error.errors.filter(
      (error) =>
        // @ts-expect-error custom field
        error.type !== 'validation_error' &&
        // Workaround for incorrect BE type
        // Message _can_ sometimes be undefined in GraphQLFormattedError

        !error.message.includes('Cannot return null for non-nullable field')
    )

    if (errors.length) registerError({ ...error, errors })
  } else if (CombinedProtocolErrors.is(error)) {
    // Handle multipart subscription protocol errors
    registerError(error)
  } else if (LocalStateError.is(error)) {
    // Handle errors thrown by the `LocalState` class
    registerError(error)
  } else if (ServerError.is(error)) {
    // Handle server HTTP errors
    // SKIP
  } else if (ServerParseError.is(error)) {
    // Handle JSON parse errors
    registerError(error)
  } else if (UnconventionalError.is(error)) {
    // Handle errors thrown by irregular types
    registerError(error)
  } else {
    // Handle other errors
    registerError(error)
  }
}
